var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNut = function SvgIconNut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.625a4.375 4.375 0 1 0 0 8.75 4.375 4.375 0 0 0 0-8.75M9.625 12a2.375 2.375 0 1 1 4.75 0 2.375 2.375 0 0 1-4.75 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.358c-.302 0-.599.08-.86.23L3.265 6.04a1.76 1.76 0 0 0-.891 1.52v8.88a1.76 1.76 0 0 0 .89 1.52l.002.001 7.872 4.451a1.73 1.73 0 0 0 1.722 0l7.873-4.452a1.76 1.76 0 0 0 .891-1.52l-1-.006h1V7.56a1.76 1.76 0 0 0-.89-1.52L12.86 1.588a1.73 1.73 0 0 0-.861-.23m7.625 14.932V7.71L12 3.398 4.375 7.71v8.58L12 20.602z"
  }))));
};
export default SvgIconNut;